import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { Loader, ButtonModifier } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Button } from "@mui/material";
import useScreenWidth from "../../../hooks/useScreenWidth";
import { formatDate } from "../../../constants/helper";

const TampilKirimGambar = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [noKirimGambar, setNoKirimGambar] = useState("");
  const [tanggalKirimGambar, setTanggalKirimGambar] = useState("");
  const [noRab, setNoRab] = useState("");
  const [tanggalDpRab, setTanggalDpRab] = useState("");
  const [gambarKe, setGambarKe] = useState("");
  const [keteranganKirimGambar, setKeteranganKirimGambar] = useState("");

  const navigate = useNavigate();
  let isEditableManager = user.tipeUser !== "ADMIN";
  // let isEditable = isEditableManager;
  let isEditable = true;

  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getKirimGambarById();
  }, []);

  const getKirimGambarById = async () => {
    setLoading(true);
    const response = await postRequest(
      `/kirimGambars/${id}`,
      {},
      navigate,
      dispatch
    );
    setNoKirimGambar(response.data.noKirimGambar);
    setTanggalKirimGambar(formatDate(response.data.tanggalKirimGambar));
    setNoRab(response.data.rab.noRab);
    setTanggalDpRab(formatDate(response.data.rab.tanggalDpRab));
    setGambarKe(response.data.gambarKe);
    setKeteranganKirimGambar(response.data.keteranganKirimGambar);
    setLoading(false);
  };

  const deleteKirimGambar = async (id) => {
    setLoading(true);
    await postRequest(`/deleteKirimGambar/${id}`, {}, navigate, dispatch);
    navigate("/daftarKirimGambar");
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Proyek</h3>
      <h5 style={{ fontWeight: 400 }}>Kirim Gambar</h5>
      <hr />
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate("/daftarKirimGambar")}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>
      <Box sx={buttonModifierContainer}>
        {isEditable && (
          <>
            <ButtonModifier
              id={id}
              kode={"test"}
              addLink={null}
              editLink={`/daftarKirimGambar/kirimGambar/${id}/edit`}
              deleteUser={deleteKirimGambar}
              nameUser={noKirimGambar}
            />
          </>
        )}
      </Box>
      <Form>
        <Card>
          <Card.Header>Kirim Gambar</Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. Kirim Gambar :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={noKirimGambar}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Kirim Gambar :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={tanggalKirimGambar}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. RAB :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={noRab} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. DP RAB :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={tanggalDpRab} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Gambar Ke- :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={gambarKe} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      as="textarea"
                      rows={4}
                      value={keteranganKirimGambar}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Form>
    </Container>
  );
};

export default TampilKirimGambar;

const buttonModifierContainer = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const subTitleText = {
  fontWeight: "900",
};
